module.exports = __webpack_public_path__ + "img/main-footer.4bd03139.jpg";